import { useInfiniteQuery } from "@tanstack/react-query"

import { peopleService } from "@/services/peopleService"
import { Person } from "@/types/person"

interface FetchPeopleOptions {
  statusFilter?: string
  searchQuery?: string
  functionAreaFilter?: string
  locationFilter?: string
  employerFilter?: string
  subTeamFilter?: string
  sheriffTypeFilter?: string
  personIdFilter?: string
  emailFilter?: string
  postcodeFilter?: string
  stickyLocationFilter?: string
  driverManagerTeamFilter?: string
  contractStartDateFilter?: string
  contractEndDateFilter?: string
  hpdPoolFilter?: string
  payBasisFilter?: string
  payRateFilter?: string
  contractTypeFilter?: string
  hasMultipleLocationsFilter?: "Yes" | "No" | ""
  filterTypes?: Record<string, string>
  userSubTeams?: string[]
  limit?: number
}

interface FetchPeopleResult {
  people: Person[]
  hasMore: boolean
}

export const useFetchPeople = (options: FetchPeopleOptions = {}) => {
  const {
    statusFilter = "Active",
    searchQuery = "",
    functionAreaFilter = "",
    locationFilter = "",
    employerFilter = "",
    subTeamFilter = "",
    sheriffTypeFilter = "",
    personIdFilter = "",
    emailFilter = "",
    postcodeFilter = "",
    stickyLocationFilter = "",
    driverManagerTeamFilter = "",
    contractStartDateFilter = "",
    contractEndDateFilter = "",
    hpdPoolFilter = "",
    payBasisFilter = "",
    payRateFilter = "",
    contractTypeFilter = "",
    hasMultipleLocationsFilter = "",
    filterTypes = {},
    userSubTeams = [],
    limit = 50,
  } = options

  return useInfiniteQuery<FetchPeopleResult>({
    queryKey: [
      "people",
      statusFilter,
      searchQuery,
      functionAreaFilter,
      locationFilter,
      employerFilter,
      subTeamFilter,
      sheriffTypeFilter,
      personIdFilter,
      emailFilter,
      postcodeFilter,
      stickyLocationFilter,
      driverManagerTeamFilter,
      contractStartDateFilter,
      contractEndDateFilter,
      hpdPoolFilter,
      payBasisFilter,
      payRateFilter,
      contractTypeFilter,
      hasMultipleLocationsFilter,
      filterTypes,
      userSubTeams,
    ],
    queryFn: async ({ pageParam = 0 }) => {
      const offset = pageParam as number

      const result = await peopleService.fetchPeople({
        statusFilter,
        searchQuery,
        functionAreaFilter,
        locationFilter,
        employerFilter,
        subTeamFilter,
        sheriffTypeFilter,
        personIdFilter,
        emailFilter,
        postcodeFilter,
        stickyLocationFilter,
        driverManagerTeamFilter,
        contractStartDateFilter,
        contractEndDateFilter,
        hpdPoolFilter,
        payBasisFilter,
        payRateFilter,
        contractTypeFilter,
        hasMultipleLocationsFilter,
        filterTypes,
        limit,
        offset,
      })

      return {
        people: result.people,
        hasMore: result.hasMore,
      }
    },
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.hasMore ? allPages.length * limit : undefined
    },
    initialPageParam: 0,
  })
}
